export const saveSearch = searchData => fetch('https://visitor.natu.care/search', {
  method: 'POST',
  body: searchData
});
